import React, { useEffect } from 'react';
import MenuRodape from './MenuRodape';
import PagamentoContent from './Pagamentos';
import ProdutosContent from './ProdutosContent';
import ClienteContent from './ClienteContent';
import { Table, Card, Form, Row, Col, Button, Spinner } from 'react-bootstrap';

import { useProvider, Toast } from '../../context/MenuProvider';
import { Link, useParams, useNavigate} from 'react-router-dom';


import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");

const baixarCliente = (cliente_id) => {
    const mensagem = {
      tipo: 'baixar-cliente',
      id: parseInt(cliente_id)
    };

    // ✅ FLUXO PWA
    if (navigator.serviceWorker && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage(mensagem);
    } 
    // ✅ FLUXO NATIVO (APK)
    else {
        // No nativo, enviamos para a própria window pois o service-worker.js
        // foi carregado como um script comum que ouve a window.
        window.postMessage(mensagem, '*');
    }
}

const Home = ({id, venda, setVenda}) => {
  const { 
    crud,
    salvarDados,
    buscarDadosPorId,
    excluirDadosPorId,
    setTitle,
    setTour,
    setLinks,
    setBtns,
  } = useProvider();
  const navigate = useNavigate();
  const { post, get, loading } = crud || {};
  
  if(!id) setTitle('Checkout');
  if(id) setTitle('Venda');
  // useEffect(()=>{
  //     const carregarCheckout = async () => {
  //       try {
  //         const response = await buscarDadosPorId('local_registros', 'checkout');
  //         if (response) {
  //           if (!response?.venda?.cliente){
  //             navigate("/checkout/selecionar-cliente",{ replace:true });
  //           }
  //         } else {
  //           //alert(`Response: ${JSON.stringify(response)}`)
  //           console.warn('Response não é um array ou está vazio');
  //         }
  //       } catch (error) {
  //         //alert(`Catx: ${error}`)
  //         //alert(error)
  //         console.error('Erro ao carregar checkout:', error);
  //       }
  //     };
  //     carregarCheckout();
  // },[venda])
  
  useEffect(() => {
      const tour = {
        id:"ckSelectCarrinho",
        lista:[
          {
            id: "#gvendas",
            titulo: `Carrinho da Venda`,
            descricao: `Aqui nessa tela você confere os itens e a forma de pagamenro da venda`,
            prev: false,
            next: true,
            finish: false
          },
          {
            id: "#listaCkItensProdutos",
            titulo: "Itens da Venda",
            descricao: "Aqui você ver os produtos da venda.",
            prev: true,
            next: true,
            finish: false
          },
          {
            id: "#btnCkAddMaisProdutos",
            titulo: "Mais produtos",
            descricao: "Aqui você pode incluir mais produtos à sua venda.",
            prev: true,
            next: true,
            finish: false
          },
          {
            id: "#btnCkAddDesconto",
            titulo: "Adicionar Desconto",
            descricao: "Aqui você pode aplicar desconto na venda.",
            prev: true,
            next: true,
            finish: false
          },
          {
            id: "#listaCkPagamentos",
            titulo: "Forma de pagamento",
            descricao: "Aqui você vai informar a forma de pagamento combinada com o cliente.",
            prev: true,
            next: true,
            finish: false
          },
          {
            id: "#btnAddCkPagamentos",
            titulo: "Parcelamento",
            descricao: "Aqui você pode adicionar movas parcelas para dovidir o valor da venda.",
            prev: true,
            next: true,
            finish: false
          },
          {
            id: "#btnAddCkFecharVenda",
            titulo: "Finalizar venda",
            descricao: "Aqui, após conferir tudo, pode finalizar o fechamento da venda.",
            prev: true,
            next: false,
            finish: true
          },
        ]
      }
      setLinks([
        // { name: 'Nova Venda', to: '/vendas/novo' },
        // { name: 'Novo Produto', to: '/produtos/novo' },
        // { name: 'Novo Cliente', to: '/clientes/novo' },
        //{ name: 'Configurações', to: '/configuracoes' },
      ]);
      setBtns([
        //{icon:'bi-arrow-repeat', to:`/painel/sync`, id:"btnSync"},
      ]);
      setTour(tour);
      return () => {setLinks([]); setBtns([]); setTour({});}
  }, [setLinks, setBtns, setTour]);
  

  
  const fecharVenda = async () => {
    var listaPagamentos = [];
    var itensVenda = [];
    if (!venda) return;
  
    venda.pagamentos.forEach((item) => {
      listaPagamentos.push({
        valor: item.valor,
        pago: item.pago,
        data_do_pagamento: item.data,
        data_do_vencimento: item.data,
        forma_de_pagamento: item.pagamento,
      });
    });
  
    venda.itens.forEach((item) => {
      itensVenda.push({
        produto: item.produto.id,
        quantidade: item.quantidade,
        preco_unitario: item.valor,
      });
    });
    //alert(JSON.stringify(venda.cliente))
  
    let vendaData = {
      venda_itensvenda: itensVenda,
      venda_pagamentos: listaPagamentos,
      data_da_venda: venda.data,
      desconto: parseFloat(venda.desconto || 0).toFixed(2),
      observacoes: venda.observacoes,
      cliente: parseInt(venda.cliente.id || venda.cliente),
    };
    // alert(JSON.stringify(vendaData))
    // const texto = JSON.stringify(vendaData);
    
    // navigator.clipboard.writeText(texto)
    //   .then(() => console.log("Copiado!"))
    //   .catch(err => console.error("Erro ao copiar", err));
  
    try {
      const response = await post(vendaData, `/gvendas/vendas/?filtros=id`, null, 'venda', true, 5000);
      if (response && response.length) {
        //alert(JSON.stringify(response))
        baixarCliente(parseInt(venda?.cliente?.id || venda?.cliente));
        navigate(`/vendas/${response[0].id}`, { replace: true });
        await excluirDadosPorId("local_registros","checkout");
        Toast.fire({
          icon: "success",
          title: `Venda salva com sucesso`,
        });
      }
    } catch (err) {
      alert(
        err?.response?.data?.detail ||
        err?.response?.data?.error ||
        err?.response?.data ||
        err.message ||
        JSON.stringify(err)
      )
       if (err.code === 'ERR_NETWORK' || err.code === 'ECONNABORTED' || !err.response ) {
        await salvarDados('db_sync', {
          metodo: "POST",
          titulo: `Nova venda de ${venda?.desconto>0 ? `${parseFloat(parseFloat(venda?.total || 0)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} por `:""}${parseFloat(parseFloat(venda?.total || 0) - parseFloat(venda?.desconto || 0)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`,
          descricao: `
            <div class="small">Data da venda: ${dayjs(venda.data).format("DD/MM/YYYY")}</div>
            <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr><th>${venda?.cliente?.nome_do_cliente || 'Cliente não informado'}</th></tr>
              </thead>
              <tbody>
                ${venda?.itens?.map((item) => `
                  <tr>
                    <td>${item.quantidade}x ${item.produto?.nome_do_produto} - ${parseFloat(item.valor || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                  </tr>
                `).join('')}
                <tr><th>Pagamentos</th></tr>
                ${venda?.pagamentos?.map((item) => `
                  <tr>
                    <td>${dayjs(item.data).format("DD/MM/YYYY")} - ${parseFloat(item.valor || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}${item?.pago ? ' (pago)' : ''}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
            </div>
          `,
          url: `/gvendas/vendas/?filtros=id`,
          dados: vendaData,
          tipo:"baixar-cliente",
          id:venda?.cliente?.id,
          data: new Date().toLocaleString("sv-SE"),
        });
        Toast.fire({
          icon: "success",
          title: `Venda salva na fila Sync`,
        });
        await excluirDadosPorId("local_registros","checkout");
        //Colocar url da fila;
        navigate(`/painel/sync`, { replace: true });
      }
      else{
        //alert(JSON.stringify(err.response))
        Toast.fire({
            icon: "error",
            title: "Falha ao salvar a venda"
        });
      }
      console.error(err); // Adicione tratamento de erro conforme necessário
    } finally {
      // Finalize qualquer lógica adicional aqui, se necessário
    }
  };
    
  const formatDate = (dateString) => {
    const [day, month, year] = dateString.split('/');
    return `${year}-${month}-${day}`;
  };
  
    
  const buscarVenda = async () => {
    try{
      const response = await get(`/gvendas/vendas/${id}/?expand=venda_pagamentos,venda_itensvenda,produto,cliente`, 'checkout');
      if(response && response.length){
        const x = response[0];
        let lPagamentos = [];
        x.venda_pagamentos.forEach((item, index) => {
          lPagamentos.push({ 
            id:item.id,
            valor:item.valor,
            pago:item.pago,
            data:formatDate(item.data_do_pagamento),
            pagamento:item.forma_de_pagamento,
          });
        });
        
        let itens = [];
        x.venda_itensvenda.forEach((item, index) => {
          itens.push({ 
            id:item.id,
            produto:item.produto,
            quantidade:item.quantidade,
            valor:item.preco_unitario,
          });
        });
        
        const obj = {
          id:x.id,
          pagamentos:lPagamentos,
          itens:itens,
          data:formatDate(x.data_da_venda),
          observacoes:x.observacoes,
          desconto:x.desconto,
          cliente:{
            id:x.cliente.id,
            telefone_do_cliente:x.cliente.telefone,
            nome_do_cliente:x.cliente.nome_do_cliente,
          },
        }
        setVenda(obj);
      }
    }catch(err){
      
    }finally{
      
    }
  }
    
  
  useEffect(()=>{
      if(id){
        buscarVenda()
      }
  },[id])
  
  
  const botao = {
    onClick:fecharVenda, 
    text:'Finalizar Venda'
  }
  
  return (
        <>
            <ClienteContent venda={venda} setVenda={setVenda} />
            <ProdutosContent venda={venda} setVenda={setVenda} />
            <PagamentoContent venda={venda} setVenda={setVenda} />
            <MenuRodape venda={venda} botao={botao}/>
        </>
    );
}

export default Home